import { render, staticRenderFns } from "./FormasPagamento.vue?vue&type=template&id=7019f88d"
import script from "./FormasPagamento.vue?vue&type=script&lang=js"
export * from "./FormasPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports